var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRotateForward = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24.75C47.5 12.1855 37.3145 2 24.75 2C12.1855 2 2 12.1855 2 24.75C2 37.3145 12.1855 47.5 24.75 47.5C33.0256 47.5 40.2691 43.0814 44.25 36.4747",
    stroke: "#6BA543",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 18.25L47.5 24.75L54 15",
    stroke: "#6BA543",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRotateForward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rotate_forward.20946bf7.svg";
export { ForwardRef as ReactComponent };